import { ViewOrderSidePanelComponent } from './ViewOrderSidePanelComponent';

export * from './useOrderSidePanel';

export const ViewOrderSidePanel = ViewOrderSidePanelComponent;
